import { Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { LazyLoadComponent } from '@src/components/LazyLoadComponent/LazyLoadComponent';

const ZonesList = lazy(() =>
    import('../../pages/Zone').then((module) => ({
        default: module.ZonesList,
    }))
);

export function ZonesContainer() {
    return (
        <Routes>
            <Route
                path={'*'}
                element={
                    <LazyLoadComponent type="LIST" Component={<ZonesList />} />
                }
            />
        </Routes>
    );
}
